export const desktop = '(min-width: 736px)';
export const tablet = '(min-width: 415px)';
export const belowDesktop = '(max-width: 735px)';
